import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const PromptDirectionContext = createContext(null);
const CrossAxisOnlyContext = createContext(false);
export const PromptLayoutDataProvider = (props) => {
    var _a;
    return (_jsx(PromptDirectionContext.Provider, Object.assign({ value: props.direction }, { children: _jsx(CrossAxisOnlyContext.Provider, Object.assign({ value: (_a = props.crossAxisOnly) !== null && _a !== void 0 ? _a : false }, { children: props.children })) })));
};
export function usePromptLayoutStyles(constraints) {
    const dir = useContext(PromptDirectionContext);
    const crossAxisOnly = useContext(CrossAxisOnlyContext);
    if (!dir || !constraints) {
        return undefined;
    }
    const result = {};
    let mainConstraint, crossConstraint, mainFlexibility, crossFlexibility, crossDimension;
    if (dir === 'horizontal') {
        mainConstraint = constraints.widthConstraint;
        mainFlexibility = constraints.widthFlexibility;
        crossConstraint = constraints.heightConstraint;
        crossFlexibility = constraints.heightFlexibility;
        crossDimension = 'height';
    }
    else {
        mainConstraint = constraints.heightConstraint;
        mainFlexibility = constraints.heightFlexibility;
        crossConstraint = constraints.widthConstraint;
        crossFlexibility = constraints.widthFlexibility;
        crossDimension = 'width';
    }
    if (!crossAxisOnly) {
        if (mainConstraint) {
            result.flexBasis = mainConstraint;
        }
        switch (mainFlexibility) {
            case 'flexible':
                result.flexShrink = 1;
                result.flexGrow = 1;
                break;
            case 'growable':
                result.flexGrow = 1;
                break;
            case 'shrinkable':
                result.flexShrink = 1;
                break;
            case 'fixed':
                result.flexShrink = 0;
                result.flexGrow = 0;
                break;
        }
    }
    switch (crossFlexibility) {
        case 'flexible':
        case 'growable':
            result[crossDimension] = '100%';
            break;
    }
    if (crossConstraint) {
        result[crossDimension] = crossConstraint;
    }
    return result;
}
